import {observable, action, computed} from 'mobx';
import moment from "moment";

export const filterDateOptions = [
    { value: "date_taken", label: "Date Taken" },
    { value: "date_modified", label: "Date Modified" },
    { value: "date_created", label: "Date Created"}
];

export default class StationImageStore {
    @observable stationImages = [];
    @observable stationAlbums = [];
    @observable selectedAlbum = "All";

    api;

    constructor(transportLayer) {
        this.api = transportLayer;
    }

    fetchStationComparisonImages = (filter1, filter2) => Promise.all([
        this.api.fetchStationImages(filter1),
        this.api.fetchStationImages(filter2),
    ]);

    @action fetchStationImages = async (payload) => {
        try {
            const stationImages = await this.api.fetchStationImages(payload);

            this.stationImages = stationImages;

            return stationImages;
        } catch(e) {
            return e;
        }
    }

    @action fetchAlbums = async (payload) => {
        try {
            const stationAlbums = await this.api.fetchAlbumsByStationID(payload);

            this.stationAlbums = [{album_code: 'All'}, ...stationAlbums];

            return stationAlbums;
        } catch(e) {
            return e;
        }
    }

    @action setSelectedAlbum = (album) => {
        this.selectedAlbum = album;
    }

    getSpecifiedDateRange = (key) => {
        let timeRange = {};

        this.stationImagesFilteredBySelectedAlbum.forEach(image => {
            const time = image[key];

            const date = moment(time).seconds(0).valueOf();

            if (!timeRange[date]) timeRange = Object.assign(timeRange, {[date]: time});
        });

        return Object.keys(timeRange).sort((a, b) => +a < +b ? -1 : 1).map((key, index) => ({
            value: index,
            epoch: key,
            date: timeRange[key]
        }));
    }

    @computed get dateTakenRange () {
        return this.getSpecifiedDateRange('date_taken');
    }

    @computed get dateCreatedRange () {
        return this.getSpecifiedDateRange('date_created');
    }

    @computed get dateModifiedRange () {
        return this.getSpecifiedDateRange('date_modified');
    }

    @computed get stationImagesFilteredBySelectedAlbum () {
        if (this.selectedAlbum === "All") {
            return this.stationImages;
        } else {
            return this.stationImages.filter(image => image.album_code === this.selectedAlbum);
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/IDaq/StationImageStore.js